<template>
  <div class="modal is-active">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Change Pro Expiration Date</p>
      </header>
      <section class="modal-card-body">
        <form @submit.prevent="confirmChangeProExpirationDate">
          <div class="field">
            <FlatPickr
              v-model="newProExpirationDate"
              :config="dateConfig"
              class="input" />

            <p class="help is-danger" v-if="newProExpirationDateError">{{ newProExpirationDateError }}</p>
          </div>

          <input type="submit" style="display: none"/>
        </form>

        <!-- Error notification section -->
        <div class="notification is-danger" v-if="changeProExpirationDateError">
          {{changeProExpirationDateError}}
        </div>
      </section>
      <footer class="modal-card-foot">
        <div class="container">
          <div class="is-pulled-left">
            <button
              v-if="user.subscriptionExpirationDate"
              class="button is-danger"
              @click="removeSubscriptionClicked"
              :class="{'is-loading': isRemovingSubscription}"
              :disabled="isRemovingSubscription || isChangingProExpirationDate"
            >Remove Subscription</button>
          </div>

          <div class="is-pulled-right">
            <button
              class="button"
              @click="cancelChangeProExpirationDate"
              :disabled="isChangingProExpirationDate || isRemovingSubscription"
            >Cancel</button>
            <button
              class="button is-primary"
              @click="confirmChangeProExpirationDate"
              :class="{'is-loading': isChangingProExpirationDate}"
              :disabled="isChangingProExpirationDate || isRemovingSubscription"
            >Change Date</button>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import FlatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

import {
  GET_USER,
  UPDATE_PRO_EXPIRATION_DATE,
  REMOVE_PRO_SUBSCRIPTION
} from "./userStore";

export default {
  name: "UserChangeProExpirationDateModal",

  components: { FlatPickr },

  props: {
    userStorePath: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      newProExpirationDate: null,
      isChangingProExpirationDate: false,
      newProExpirationDateError: null,
      changeProExpirationDateError: null,
      isRemovingSubscription: false
    };
  },

  mounted() {
    this.newProExpirationDate = this.currentSubscriptionExpirationDate;
  },

  computed: {
    dateConfig () {
      return {
        enableTime: false,
        dateFormat: 'Y-m-d',
        minDate: this.currentSubscriptionExpirationDate,
        locale: {
          firstDayOfWeek: 1
        }
      }
    },

    currentSubscriptionExpirationDate() {
      if (!this.user.subscriptionExpirationDate) {
        return new Date();
      }

      return dayjs(this.user.subscriptionExpirationDate).toDate()
    },

    user() {
      const getUser = `${this.userStorePath}/${GET_USER}`;
      return this.$store.getters[getUser];
    }
  },

  methods: {
    cancelChangeProExpirationDate() {
      this.$emit("cancelled");
    },

    async confirmChangeProExpirationDate() {
      if (this.newProExpirationDate === null) {
        this.newProExpirationDateError = "Date can not be empty";
        return;
      }

      var newProExpirationDate = dayjs(this.newProExpirationDate).add(1, 'day').toDate();
      newProExpirationDate.setUTCHours(21);
      newProExpirationDate.setUTCMinutes(59);
      newProExpirationDate.setUTCSeconds(59);
      newProExpirationDate.setUTCMilliseconds(999);

      this.changeProExpirationDateError = null;
      this.isChangingProExpirationDate = true;

      try {
        const updateProExpirationDateAction = `${this.userStorePath}/${UPDATE_PRO_EXPIRATION_DATE}`;
        const response = await this.$store.dispatch(updateProExpirationDateAction,
          {
            newProExpirationDate
          });

        if (!response.success) {
          this.changeProExpirationDateError = `Change Pro expiration date failed: ${response.message}`;
          return;
        }

        this.$emit("succeeded");
      } catch (error) {
        this.changeProExpirationDateError = error || 'Something went wrong.';
      } finally {
        this.isChangingProExpirationDate = false;
      }
    },

    async removeSubscriptionClicked() {
      this.changeProExpirationDateError = null;
      this.isRemovingSubscription = true;

      try {
        const removeProSubscriptionAction = `${this.userStorePath}/${REMOVE_PRO_SUBSCRIPTION}`;
        const response = await this.$store.dispatch(removeProSubscriptionAction);

        if (!response.success) {
          this.changeProExpirationDateError = `Remove Pro subscription failed: ${response.message}`;
          return;
        }

        this.$emit("succeeded");
      } catch (error) {
        this.changeProExpirationDateError = error || 'Something went wrong.';
      } finally {
        this.isRemovingSubscription = false;
      }
    }
  },

  watch: {
    newProExpirationDate() {
      this.newProExpirationDateError = null;
    },
  }
};
</script>

<style lang="scss" scoped>
.modal-card-head {
  border-bottom: 0;
}

.modal-card-foot {
  border-top: 0;
}

.notification {
  margin-top: 1em;
}
</style>
